import { useState, useCallback } from "react";

import { retrieveAuthToken } from "../../../utils/authService";
import { getCurrentSelectedTenant } from "../../../utils";
import { useChatCore } from "./useChatCore";

export type { ChatMessage } from "./useChatCore";

export function useAspenChat() {
  // Tenant is locked to the user's current selected tenant — no picker.
  const [selectedTenant] = useState<string>(() => getCurrentSelectedTenant() ?? "");

  const core = useChatCore({
    tenant: selectedTenant,
    getAuthToken: retrieveAuthToken,
    filterSessionsByTenant: true,
  });

  const handleNewChat = useCallback(() => {
    core.resetConversation();
  }, [core.resetConversation]);

  return { ...core, selectedTenant, handleNewChat };
}
